<template>
	<div class="card cardptpr infocard mb-4" :onclick="url ? 'window.open(\'' + url + '\')' : ''">
		<div class="card-header p-3 pb-0 pt-2" v-if="title">
			<H6 class="title-section">{{title}}</H6>
		</div>
		<div :class="'card-body p-0 '+this.animate">
			<div :class="'d-flex align-items-top p-3 '">
				<div class="d-flex flex-column" v-if="icon">
					<i aria-hidden="true" :class="'fas p-3 ps-0 ' + this.flag" v-if="flag"></i>
				</div>
				<!-- original source
				<div class="d-flex flex-column">
					<div class="d-flex flex-row justify-content-left text-bold text-lg">
						{{curr}} {{(div ? value / div : value) * 1 | formatNum}} {{unit}}						
					</div>
					<div class="d-flex flex-row justify-content-left text-sm">
						{{prefix}} {{info}}
					</div>
				</div>
				-->
				<div class="row w-100">
					<div v-bind:class="colmd">
						<div class="justify-content-left text-bold text-lg">
							<!--{{curr}} {{(div ? value / div : value) * 1 | formatNum}} {{unit}} -->			
							{{curr}} {{(div ? value / div : value) * 1 | formatNum}} {{unit}}					
						</div>
						<div class="justify-content-left text-sm">
							{{prefix}} {{info}}
						</div>
					</div>
					<div class="col-md-3" v-if="this.loading">
						<Loader :loading="this.loading" :customclass="''" style="min-width:50px;"/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
 
<script>
import Loader from '@/components/loader/Loader.vue'

export default{
	props:["icon", "title", "unit", "prefix", "info", "value", "url", "curr", "div", "flag", "animate", "loading"],
	components:{
		Loader,
	},
    mounted(){
    },
    methods:{
	},
	computed:{
		colmd: function() {
			return this.loading ? 'col-md-9' : 'col-md-12';
		}
	}
}

</script>
<style>
	.arrow-down-red{ color:#c7251c; }
	.arrow-up-green{ color:#4ca437; }
</style>